module.exports = __webpack_public_path__ + "static/color-logo-bd27666cd50054236f9f7776d8901cc9.png";